<div class="form-header">
    <span>{{title}}</span>
    <div>
        <button [class]="isDisabled?'disable-button':''" mat-button *ngIf="buttonTitle" (click)="btnClick()" [disabled]="isDisabled">{{buttonTitle}}</button>
        <button [class]="isDisabled?'disable-button':''" mat-button *ngIf="buttonTitle2" (click)="btnClick2()" [disabled]="isDisabled2">{{buttonTitle2}}</button>
    </div>
</div>